// Dikkat: '../../axios' yerine paketin kendisi import ediliyor. axios.ts bu
// slice'i import ettigi icin '../../axios' dongusel bagimlilik yaratirdi.
// Interceptor'lar global singleton uzerinde oldugundan davranis aynidir.
import axios from 'axios';

export const LOGOUT_PATH = '/auth/logout';

export default async function logoutRequest(): Promise<void> {
  await axios.post(
    `${process.env.REACT_APP_BASE_URL}${LOGOUT_PATH}`,
    undefined,
    { skipAutoCancel: true }
  );
}
